import { render, staticRenderFns } from "./AChip.vue?vue&type=template&id=7ac43b1c&"
import script from "./AChip.vue?vue&type=script&lang=ts&"
export * from "./AChip.vue?vue&type=script&lang=ts&"
import style0 from "./AChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VSheet})
